














import { Component, Vue, Prop } from "vue-property-decorator";
import { ColorName } from "@/api/project-api";

interface ProjectStatus {
  id: number;
  breadCrumb: ColorName[];
}

@Component({})
export default class ProjectBreadCrumbs extends Vue {
  @Prop({ default: [] }) project!: ProjectStatus;

  isActive(item: ColorName) {
    return !["inActive", "completed"].includes(item.color);
  }

  getClassName(item: ColorName): string {
    return this.isActive(item) ? "active" : item.color;
  }
}
